"use client";

import React from "react";
import styled from "styled-components";
import Flex from "../../Flex";
import type { EditableCellType } from "./EditableTableCell";
import type { CellRegistration } from "./EditableTableContext";
import BulkBooleanCell from "./BulkBooleanCell";
import BulkSelectCell from "./BulkSelectCell";
import BulkMultiSelectCell from "./BulkMultiSelectCell";
import BulkLongtextCell from "./BulkLongtextCell";
import BulkInputCell from "./BulkInputCell";

export const BULK_EDIT_BAR_HEIGHT = 44;

export const BulkRowWrapper = styled(Flex).attrs({
  borderBottom: "default",
})`
  position: sticky;
  top: 0;
  z-index: 70;
  height: ${BULK_EDIT_BAR_HEIGHT}px;
  background: white;
`;

const BulkCellWrapper = styled(Flex).attrs({
  alignItems: "center",
})`
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 0 16px;
  box-sizing: border-box;
  background: white;
  gap: 4px;
`;

export const BulkMultiSelectTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 3px;
  flex: 1;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  text-align: left;
  font-family: inherit;
  font-size: inherit;
  height: 100%;
`;

export type BulkEditInfo = {
  colIndex: number;
  type: EditableCellType;
  options?: CellRegistration["options"];
  offsetLeft: number;
  width: number;
  initialChecked: boolean;
  currencySymbol?: string;
};

type Props = {
  info: BulkEditInfo;
  onCommit: (value: string | number | boolean) => void;
};

const BulkCellContent: React.FC<Props> = ({ info, onCommit }) => {
  let content: React.ReactNode;
  if (info.type === "boolean")
    content = <BulkBooleanCell initialChecked={info.initialChecked} onCommit={onCommit} />;
  else if (info.type === "select")
    content = <BulkSelectCell options={info.options} onCommit={onCommit} />;
  else if (info.type === "multiselect")
    content = (
      <BulkMultiSelectCell colIndex={info.colIndex} options={info.options} onCommit={onCommit} />
    );
  else if (info.type === "longtext") content = <BulkLongtextCell onCommit={onCommit} />;
  else
    content = (
      <BulkInputCell type={info.type} onCommit={onCommit} currencySymbol={info.currencySymbol} />
    );

  return (
    <BulkCellWrapper style={{ left: info.offsetLeft, width: info.width }}>
      {content}
    </BulkCellWrapper>
  );
};

export default BulkCellContent;
